
import { PaperGradientBG } from "../kits";
import UnderlineSketch from "./UnderlineSketch";

/**
 * Headline component for the Profession Section
 * Displays the main heading with highlighted keywords
 * Wrapped in PaperDarkBG for consistent styling
 * Aligned with PersonaliseMarketing design language
 */
function ProfessionSectionHeadline() {
  return (
    <PaperGradientBG>
      <section className="py-16 sm:py-20 md:py-24">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          {/* Hauptbotschaft */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-amber-100 mb-6 leading-relaxed">
            Echte{" "}
            <span className="text-brand relative inline-block">
              Lösungen
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
            {" "}für deine{" "}
            <span className="text-brand relative inline-block">
              Herausforderungen
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
          </h1>

          {/* Untertitel */}
          <p className="text-sm sm:text-base font-mono text-amber-50 max-w-2xl mx-auto">
            Konkrete Probleme verdienen konkrete Antworten.
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}

export default ProfessionSectionHeadline;
